import { FC } from "react"

import CustomLineChart from "../customLineChart";
import CustomButtonRight from "../customButtonRight";

import { StatisticsObjectType } from "./types";



const CaseVolume: FC<StatisticsObjectType> = ({ StatisticsObjectType, buttonShows, startDate, endDate ,showPractice}): JSX.Element => {
    return (
        <>
            <div className="counters">
                {buttonShows &&
                    <div className="row g-0 g-md-2">
                        <CustomButtonRight startDate={startDate} endDate={endDate} StatisticsObjectType={StatisticsObjectType}
                                           showpractice={showPractice}/>
                    </div>
                }
            </div>
            <div className="row">
                <div className={` ${buttonShows ? "col-12" : "col"}`} style={{maxHeight: 550}}>
                    <CustomLineChart title="Case Volume" LineChartObject={StatisticsObjectType.case_volume}/>
                </div>
            </div>
        </>
    )
}

export default CaseVolume;
